@if (viewingContract)
{
    <h1 mat-dialog-title>Client Contracts</h1>
}
@if (disablingContract)
{
    <h3 mat-dialog-title>Disable Client Contract</h3>
}
@if (enablingContract)
{
    <h3 mat-dialog-title>Enable Client Contract</h3>
}
@if (editingContract)
{
    <h3 mat-dialog-title>Edit Client Contract:</h3>
}
@if (addingContract)
{
    <h3 mat-dialog-title>Add Client Contract:</h3>
}
@if (reprocessingInvoicePeriods)
{
    <h3 mat-dialog-title>Reprocess Invoices For Audit Period:</h3>
}

<div mat-dialog-content>
    @if (!viewingContract && !contractsLoading)
    {
        @if (clientContracts().length === 0)
        {
            <h3>No Contracts exist. Add an identifier to
                the client's integration to add start adding contracts.</h3>
        }
        @if (!clientInfo)
        {
            <h3>No client information exist. Add client information through the
                edit client option.</h3>
        }
    }

    @if (viewingContract)
    {
        @if(contractsLoading)
        {
          <div>
            <app-lt-spinner></app-lt-spinner>
          </div>
        }
        @else
        {
            <div class="row row-cols-1 row-cols-lg-2">
                @for (c of clientContracts(); track c) {
                    <div class="col mb-4" (click)="selectContract(c)" (keydown.enter)="selectContract(c)">
                        <div class="card">
                            <div class="card-header bg-secondary text-white card-header-flex">
                                <p class="header-text">Identifier Name: {{c.identifierNameValue}}</p>
                                <div>
                                    @if (c.recreateInvoicesForAuditPeriod)
                                    {
                                        <button matTooltip="Currently Reprocessing Invoices For Audit Period"
                                            class="btn warning-button" aria-label="Reprocessing Invoices Warning" title="Reprocessing Invoices Warning">
                                            <i class="bi bi-exclamation-circle-fill warning-icon"></i>
                                        </button>
                                    }

                                    @if (c.productionInvoiceReport)
                                    {
                                        <button matTooltip="Is a Production Invoice Report" class="btn px-1 green-icon"
                                            aria-label="Production Invoice Report" title="Production Invoice Report">
                                            <i class="bi bi-lock-fill"></i>
                                        </button>
                                    }

                                    @if (!c.productionInvoiceReport)
                                    {
                                        <button matTooltip="Is not a Production Invoice Report" class="btn px-1 gray-icon"
                                            aria-label="Not a Production Invoice Report" title="Not a Production Invoice Report">
                                            <i class="bi bi-unlock-fill"></i>
                                        </button>
                                    }
                                </div>
                            </div>
                            <div class="card-body w-85 full-width">
                                <div class="row row-spacing">
                                    <div class="col-6">Identifier ID</div>
                                    <div class="col">{{c.identifierIdValue}}</div>
                                </div>
                                <div class="row row-spacing">
                                    <div class="col-6">Destination Endpoint</div>
                                    <div class="col">{{getDestinationEndpointString(c.destinationEndpointId)}}</div>
                                </div>
                                <div class="row row-spacing">
                                    <div class="col-6">Mapped Integration</div>
                                    <div class="col">{{getMappedIntegrationsDisplay(c.integrationMappings)}}</div>
                                </div>
                                <div class="row row-spacing">
                                    <div class="col-6">Disabled</div>
                                    <div class="col">{{c.disabled}}</div>
                                </div>
                                <div class="row row-spacing">
                                    <div class="col-4">Start Date</div>
                                    <div class="col text-center">{{c.contractStartDate | date :'MM/dd/yyyy'}}</div>
                                </div>
                                <div class="row row-spacing">
                                    <div class="col-4">Term Date</div>
                                    <div class="col text-center">{{c.contractTermDate | date :'MM/dd/yyyy'}}</div>
                                </div>
                                <div class="row row-spacing">
                                <div class="col-4">Reinstated Date</div>
                                <div class="col text-center">{{c.contractReinstatedDate | date :'MM/dd/yyyy h:mm a'}}</div>
                                </div>
                                <div class="row row-spacing">
                                    <div class="col-4">Updated Date</div>
                                    <div class="col text-center">{{c.updatedDate | date :'MM/dd/yyyy h:mm a'}}</div>
                                </div>
                                <div class="row row-spacing">
                                    <div class="col-6">SF Customer Number</div>
                                    <div class="col">{{c.sfCustomerNumber}}</div>
                                </div>

                                <div class="edit-buttons">
                                    <button matButton="elevated" (click)="setEditing(c)"
                                        [disabled]="!checkAccess(['LOSTalker.Admin'])">
                                        Edit
                                    </button>
                                    <button matButton="elevated" (click)="setDisabling(c)"
                                        [disabled]="!checkAccess(['LOSTalker.Admin']) || c.disabled === true">
                                        Disable
                                    </button>
                                    <button matButton="elevated" (click)="setEnabling(c)"
                                        [disabled]="!checkAccess(['LOSTalker.Admin']) || c.disabled === false">
                                        Enable
                                    </button>
                                    <button matButton="elevated" (click)="goToLoans(c)">
                                        Go to Loans
                                    </button>
                                </div>
                                <div class="edit-buttons">
                                    <button matButton="elevated" (click)="addMapping(c)"
                                        [disabled]="isCurrentIntegrationMapped(c)">
                                        Map to Selected Integration
                                    </button>
                                    <button matButton="elevated" (click)="setReprocessInvoicePeriods(c)"
                                        [disabled]="c.integrationMappings === null || c.integrationMappings.length === 0 || c.recreateInvoicesForAuditPeriod === true || c.productionInvoiceReport === true">
                                        Reprocess Invoices For Audit Period
                                    </button>
                                    <button matButton="elevated" (click)="goToMetrics(c)">
                                        Go to Metrics
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>

            @if (clientContracts().length === 0)
            {
                <div class="no-records-message">No records found.</div>
            }
            @if (!clientContracts())
            {
                <div class="no-records-message">Loading failed.</div>
            }
        }
    }

    @if (addingContract || editingContract || disablingContract || enablingContract || reprocessingInvoicePeriods)
    {
        <div class="grid-container">
            @if (selectedContract !== null && (addingContract || editingContract))
            {
                <mat-grid-list class="grid-height" rowHeight="fit" gutterSize="16px" cols="3">
                    <mat-grid-tile class="grid-tile-height">
                        <div class="tile-content">
                            <div class="form-field-container">
                                <mat-form-field class="form-field-full-width" appearance="fill">
                                    <mat-label>Invoice Day</mat-label>
                                    <input matInput type="number" [(ngModel)]="selectedContract.invoiceDayOfMonth"
                                        placeholder="Enter invoice day" title="Invoice Day">
                                </mat-form-field>
                            </div>

                            <div class="switch-container">
                                <p>Production Invoice</p>
                                <app-lt-switch [(ngModel)]="selectedContract.productionInvoiceReport"></app-lt-switch>
                            </div>

                            <div class="switch-container">
                                <p>Use First Business Day</p>
                                <app-lt-switch [(ngModel)]="selectedContract.useFirstBusinessDay"></app-lt-switch>
                            </div>

                            <div class="switch-container">
                                <p>Recreate Invoices For Audit Period</p>
                                <app-lt-switch
                                [(ngModel)]="selectedContract.recreateInvoicesForAuditPeriod"
                                [disabled]="selectedContract.integrationMappings !== null && selectedContract.integrationMappings.length > 0"></app-lt-switch>
                            </div>

                            <div class="form-field-container">
                                <mat-form-field class="form-field-full-width" appearance="fill">
                                    <mat-label>Comments</mat-label>
                                    <textarea matInput [(ngModel)]="selectedContract.comments"
                                            placeholder="Enter comments" title="Comments"></textarea>
                                </mat-form-field>
                            </div>

                            <div class="form-field-container">
                                <mat-form-field class="form-field-full-width" appearance="fill">
                                    <mat-label>Current Completed Field</mat-label>
                                    <textarea matInput [(ngModel)]="selectedContract.currentCompletedField"
                                            placeholder="Enter current completed field" title="Current Completed Field"></textarea>
                                </mat-form-field>
                            </div>
                            
                            @if (selectedContract)
                            {
                                <div class="date-section">
                                    @if (!editingContractTermDate)
                                    {
                                        <p class="date-label">Contract Term Date</p>
                                    }

                                    @if (originalContractTermDate)
                                    {
                                        <p class="original-date">Original: {{originalContractTermDate | date :'MM/dd/yyyy h:mm a'}}</p>
                                    }
                                    @else
                                    {
                                        <p class="original-date">Original: null</p>
                                    }

                                    @if(editingContractTermDate)
                                    {
                                        <app-lt-datetimepicker
                                            class="datepicker-width"
                                            placeholder="Contract Term Date"
                                            format="MM/dd/yyyy hh:mm:ss a"
                                            [disabled]="!editingContractStartDate"
                                            [fillMode]="'fill'"
                                            [(ngModel)]="selectedContract.contractTermDate">
                                        </app-lt-datetimepicker>
                                    }
                                    @else
                                    {
                                        <div class="button-container">
                                            @if (selectedContract.contractTermDate)
                                            {
                                                <button id="btnEditContractTermDate" matButton="elevated"
                                                    (click)="editingContractTermDate=true"
                                                    [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])">
                                                    Edit Contract Term Date
                                                </button>
                                            }
                                            @else
                                            {
                                                <button id="btnAddContractTermDate" matButton="elevated"
                                                    (click)="editingContractTermDate=true"
                                                    [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])">
                                                    Add Contract Term Date
                                                </button>
                                            }
                                        </div>
                                    }
                                </div>
                            }

                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile class="grid-tile-height">
                        <div class="tile-content">
                        @if (selectedContract)
                        {
                            <div class="date-section">
                            <p class="date-label">Contract Reinstated Date</p>
                            @if (originalContractReinstatedDate)
                            {
                                <p class="original-date">Original: {{originalContractReinstatedDate | date :'MM/dd/yyyy h:mm a'}}</p>
                            }
                            @else
                            {
                                <p class="original-date">Original: null</p>
                            }
                            
                            @if(editingContractReinstatedDate)
                            {
                                <app-lt-datetimepicker
                                    class="datepicker-width"
                                    placeholder="Contract Reinstated Date"
                                    format="MM/dd/yyyy hh:mm:ss a"
                                    [disabled]="!editingContractStartDate"
                                    [fillMode]="'fill'"
                                    [(ngModel)]="selectedContract.contractReinstatedDate">
                                </app-lt-datetimepicker>
                            }
                            @else
                            {
                                <div class="button-container">
                                    @if (selectedContract.contractReinstatedDate)
                                    {
                                        <button id="btnEditContractReinstatedDate" matButton="elevated"
                                            (click)="editingContractReinstatedDate=true"
                                            [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])">
                                            Edit Contract Reinstated Date
                                        </button>
                                    }
                                    @else
                                    {
                                        <button id="btnAddContractReinstatedDate" matButton="elevated"
                                            (click)="editingContractReinstatedDate=true"
                                            [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])">
                                            Add Contract Reinstated Date
                                        </button>
                                    }
                                </div>
                            }
                            </div>

                            <div class="date-section">
                            <p class="original-date">Original: {{originalContractStartDate | date :'MM/dd/yyyy'}}</p>
                            <app-lt-datepicker
                                class="datepicker-width"
                                placeholder="Contract Start Date"
                                format="MM/dd/yyyy"
                                [disabled]="!editingContractStartDate"
                                [fillMode]="'fill'"
                                [(ngModel)]="selectedContract.contractStartDate">
                            </app-lt-datepicker>
                            </div>

                            <div class="date-section">
                            <p class="original-date">Original: {{originalBillingStartDate | date :'MM/dd/yyyy'}}</p>
                            <app-lt-datepicker
                                class="datepicker-width"
                                placeholder="Billing Start Date"
                                fillMode="fill"
                                [disabled]="!editingBillingStartDate"
                                format="MM/dd/yyyy"
                                [(ngModel)]="selectedContract.billingStartDate">
                            </app-lt-datepicker>
                            </div>
                        }

                            <div class="form-field-container">
                                <mat-form-field class="form-field-full-width" appearance="fill">
                                    <mat-label>Identifer</mat-label>
                                    <mat-select [(ngModel)]="contractIdentifier" (selectionChange)="selectNewIdentifier()"
                                        [disabled]="availableIdentifiers.length === 0">
                                        @for (identifier of availableIdentifiers; track identifier) {
                                            <mat-option
                                                [value]="identifier">{{identifier.integrationName}} -
                                                {{getDestinationEndpointString(identifier.destinationId)}} -
                                                {{identifier.identifierIdValue}}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="form-field-container">
                                <mat-form-field class="form-field-full-width" appearance="fill" width="350">
                                    <mat-label>Identifier Name</mat-label>
                                    <input matInput [(ngModel)]="selectedContract.identifierNameValue"
                                        placeholder="Enter identifier name" title="Identifier Name">
                                </mat-form-field>
                            </div>
                            
                            <div class="form-field-container">
                                <mat-form-field class="form-field-full-width" appearance="fill">
                                    <mat-label>Identifier ID</mat-label>
                                    <input matInput [(ngModel)]="selectedContract.identifierIdValue"
                                        placeholder="Enter identifier ID" title="Identifier ID">
                                </mat-form-field>
                            </div>

                            <div class="form-field-container">
                                <mat-form-field class="form-field-full-width" appearance="fill">
                                    <mat-label>SF Customer Number</mat-label>
                                    <input matInput [(ngModel)]="selectedContract.sfCustomerNumber"
                                        placeholder="Enter SF Customer Number" title="SF Customer Number">
                                </mat-form-field>
                            </div>

                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile class="grid-tile-height">
                        <div class="tile-content">
                            <div class="integration-mapping-container">
                                <h4>Mapped Integrations</h4>

                                @for (intMapping of selectedContract.integrationMappings; track intMapping) {
                                    <div class="mapping-item">
                                        <div class="mapping-row">
                                            <span class="mapping-label">{{getIntegrationName(intMapping.integrationId)}}</span>
                                            @if (selectedContract)
                                            {
                                                <button matButton="elevated"
                                                    (click)="deleteIntegrationMapping(intMapping)"
                                                    [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])"
                                                    class="delete-mapping-btn">
                                                    Delete Mapping
                                                </button>
                                            }
                                        </div>
                                        <hr class="mapping-separator"/>
                                    </div>
                                }
                                <br/>
                                
                                <h4 class="client-info-section">Client Information</h4>
                                <div class="info-row">
                                    <strong>Client Contract ID:</strong> 
                                    {{selectedContract.clientContractId}}
                                </div>
                                <hr class="info-separator" />

                                <div class="info-row">
                                    <strong>Client Information ID:</strong> 
                                    <span>{{selectedContract.clientInformationId}}</span>
                                </div>
                                <hr class="info-separator" />

                                <div class="info-row">
                                    <strong>Client Full Name:</strong> 
                                    <span>{{clientInfo?.clientFullName}}</span>
                                </div>
                                <hr class="info-separator" />

                                <div class="info-row">
                                    <strong>Client Short Name:</strong>
                                <span>{{clientInfo?.clientShortName}}</span>
                                </div>
                                <hr class="info-separator" />

                                <div class="info-row">
                                    <strong>Contract Destination:</strong> 
                                    {{getDestinationEndpointString(selectedContract.destinationEndpointId)}}
                                </div>
                                
                            </div>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            }
        </div>

        @if (disablingContract || enablingContract || reprocessingInvoicePeriods)
        {
            <div class="contract-summary">
                <p><span>Identifier: {{selectedContract.identifierNameValue}} -
                    {{getDestinationEndpointString(selectedContract.destinationEndpointId)}} -
                    {{selectedContract.identifierIdValue}}</span></p>
                <p><span>Contract Start Date: {{selectedContract.contractStartDate | date :'MM/dd/yyyy'}}</span></p>
                <p><span>Billing Start Date: {{selectedContract.billingStartDate | date :'MM/dd/yyyy'}}</span></p>
                <p><span>Comments: {{selectedContract.comments}}</span></p>
            </div>
        }
    }

</div>
<div mat-dialog-actions>
    @if (viewingContract)
    {
        <button matButton="elevated" (click)="setAdding()"
            [disabled]="availableIdentifiers.length === 0  || !checkAccess(['LOSTalker.Admin'])">
            <span matTooltip="All Identifiers IDs have an associated contract."
                [matTooltipDisabled]="!(availableIdentifiers.length === 0)">Add</span>
        </button>
    }

    @if (addingContract)
    {
        <button class="btnSaveIntegration" matButton="elevated" (click)="addClientContract()"
            [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])">
            Save Client Contract
        </button>
    }

    @if (editingContract)
    {
        <button class="btnSaveIntegration" matButton="elevated" (click)="updateClientContract()"
            [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])">
            Update Client Contract
        </button>
    }

    @if (disablingContract)
    {
        <button class="btnSaveIntegration" matButton="elevated" (click)="disableContract()"
            [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])">
            Disable Client Contract
        </button>
    }

    @if (enablingContract)
    {
        <button class="btnSaveIntegration" matButton="elevated" (click)="enableContract()"
            [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])">
            Enable Client Contract
        </button>
    }

    @if (reprocessingInvoicePeriods)
    {
        <button class="btnSaveIntegration" matButton="elevated" (click)="reprocessInvoicePeriods()"
            [disabled]="savingClientContract || !checkAccess(['LOSTalker.Admin'])">
            Reprocess Invoice Periods
        </button>
    }

    @if (addingContract || editingContract || disablingContract || enablingContract || reprocessingInvoicePeriods)
    {
        <button matButton="elevated" (click)="cancel()">
            Cancel
        </button>
    }

</div>
